module.exports = __webpack_public_path__ + "static/media/bg.dc4ce22b.jpg";